export default __webpack_public_path__ + "assets/6f5499.svg";